import { useStore } from '../contexts/StoreContext'
import toast from 'react-hot-toast'

/**
 * Hook para validar que el store esté aprobado y activo antes de permitir acciones
 */
export const useStoreValidation = () => {
  const { activeStore } = useStore()

  const isStoreApproved = (): boolean => {
    if (!activeStore) {
      return false
    }

    // Normalizar isActive - el tipo Store usa isActive, pero los datos del backend pueden venir como is_active
    const isActive = (activeStore as any).is_active !== undefined 
      ? (activeStore as any).is_active 
      : activeStore.isActive !== undefined 
        ? activeStore.isActive 
        : false

    return activeStore.status === 'approved' && isActive === true
  }

  const requireApprovedStore = (actionName: string = 'esta acción'): boolean => {
    if (!activeStore) {
      toast.error('No hay un negocio seleccionado. Por favor, selecciona un negocio primero.')
      return false
    }

    if (activeStore.status === 'pending') {
      toast.error(
        `Tu negocio está pendiente de aprobación. No puedes ${actionName} hasta que sea aprobado por el administrador.`,
        { duration: 5000 }
      )
      return false
    }

    if (activeStore.status === 'rejected') {
      toast.error(
        'Tu negocio fue rechazado. Por favor, contacta al administrador para más información.',
        { duration: 5000 }
      )
      return false
    }

    if (activeStore.status === 'suspended') {
      toast.error(
        `Tu negocio está suspendido. No puedes ${actionName} hasta que sea reactivado por el administrador.`,
        { duration: 5000 }
      )
      return false
    }

    // Normalizar isActive - el tipo Store usa isActive, pero los datos del backend pueden venir como is_active
    const isActive = (activeStore as any).is_active !== undefined 
      ? (activeStore as any).is_active 
      : activeStore.isActive !== undefined 
        ? activeStore.isActive 
        : false

    if (activeStore.status === 'approved' && !isActive) {
      toast.error(
        `Tu negocio está inactivo. Por favor, activa tu negocio en la configuración para ${actionName}.`,
        { duration: 5000 }
      )
      return false
    }

    return true
  }

  const getStoreStatusMessage = (): string | null => {
    if (!activeStore) {
      return null
    }

    switch (activeStore.status) {
      case 'pending':
        return 'Tu negocio está pendiente de aprobación. Algunas funcionalidades estarán deshabilitadas hasta que sea aprobado.'
      case 'rejected':
        return 'Tu negocio fue rechazado. Por favor, contacta al administrador para más información.'
      case 'suspended':
        return 'Tu negocio está suspendido. Algunas funcionalidades estarán deshabilitadas hasta que sea reactivado.'
      case 'approved':
        // Normalizar isActive - el tipo Store usa isActive, pero los datos del backend pueden venir como is_active
        const isActive = (activeStore as any).is_active !== undefined 
          ? (activeStore as any).is_active 
          : activeStore.isActive !== undefined 
            ? activeStore.isActive 
            : false
        if (!isActive) {
          return 'Tu negocio está inactivo. Actívalo en la configuración para habilitar todas las funcionalidades.'
        }
        return null
      default:
        return null
    }
  }

  return {
    isStoreApproved: isStoreApproved(),
    requireApprovedStore,
    getStoreStatusMessage,
    activeStore
  }
}

